<template>
  <div id="side-bar">
    <b-list-group flush class="no-border">
      <!-- :::::::::::::::::::::::::::: MENU LIST :::::::::::::::::::::::::::: -->
      <b-list-group-item class="menu-top border-bottom">
        <b-icon icon="slack" animation="spin" class="mr-3" /> Menu de Opções
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU CLIENTE :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('CLIENTE')" button class="menu-top" @click="display('CLIENTE')">
        <b-icon icon="briefcase" variant="info" class="mr-3" /> Clientes
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU COMPRAS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('COMPRA')" v-b-toggle.compras button class="menu-top">
        <b-icon icon="cart3" class="mr-3" variant="info" /> Compras
      </b-list-group-item>
      <b-collapse id="compras">
        <b-list-group>
          <b-list-group-item variant="secondary" button @click="display('FORNECEDOR')">
            <b-icon variant="info" icon="briefcase-fill" class="mr-3" />Fornecedores
          </b-list-group-item>
          <b-list-group-item variant="secondary" button disabled @click="display('SOLICITAÇÕES')">
            <b-icon variant="info" icon="cart-plus" class="mr-3" />Solicitações
          </b-list-group-item>
        </b-list-group>
      </b-collapse>
      <!-- :::::::::::::::::::::::::::: MENU VEÍCULOS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('ARMAZEM')" v-b-toggle.armazenagem button class="menu-top">
        <b-icon icon="building" class="mr-3" variant="info" /> Armazém
      </b-list-group-item>
      <b-collapse id="armazenagem">
        <b-list-group>
          <b-list-group-item variant="secondary" button @click="display('ENTRADA')">
            <b-icon variant="info" icon="box-arrow-in-down-right" class="mr-3" />Entradas
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('SAIDA')">
            <b-icon variant="info" icon="box-arrow-up-left" class="mr-3" />Saídas
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('ARMAZENADO')">
            <b-icon variant="info" icon="box-seam" class="mr-3" />Armazenados
          </b-list-group-item>
          <b-list-group-item variant="secondary" button disabled @click="display('ALMOXARIFADO')">
            <b-icon variant="info" icon="box-seam" class="mr-3" />Almoxarifado
          </b-list-group-item>
          <b-list-group-item variant="secondary" button disabled @click="display('CUSTO')">
            <b-icon variant="info" icon="box-seam" class="mr-3" />Custo de Serviço
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('PRIORIDADE')">
            <b-icon variant="info" icon="bar-chart-steps" class="mr-3" />Prioridades
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('PRIORIDADE_DASH')">
            <b-icon variant="info" icon="layout-wtf" class="mr-3" />Dashboard
          </b-list-group-item>
        </b-list-group>
      </b-collapse>
      <!-- :::::::::::::::::::::::::::: MENU VEÍCULOS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('TRANSPORTE')" button class="menu-top" @click="display('TRANSPORTE')">
        <b-icon icon="truck" class="mr-3" variant="info" /> Transporte
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU IMAGENS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('IMAGEM')" button class="menu-top" @click="display('IMAGEM')">
        <b-icon icon="image" variant="info" class="mr-3" /> Banco de Imagens
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('EQUIPAMENTO')" button class="menu-top" @click="display('EQUIPAMENTO')">
        <b-icon icon="tools" variant="info" class="mr-3" /> Lista de Equipamentos
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU INSPEÇÃO :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('INSPECAO')" v-b-toggle.inspecoes button class="menu-top">
        <b-icon icon="search" class="mr-3" variant="info" /> Inspeção
      </b-list-group-item>
      <b-collapse id="inspecoes">
        <b-list-group>
          <b-list-group-item variant="secondary" button @click="display('DOCUMENTO')">
            <b-icon variant="info" icon="files" class="mr-3" />Documentos
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('INSTRUMENTO')">
            <b-icon variant="info" icon="compass" class="mr-3" />Instrumentos
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('PROFISSIONAL')">
            <b-icon variant="info" icon="file-person-fill" class="mr-3" />Profissionais
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('CONSUMIVEL')">
            <b-icon variant="info" icon="box-seam" font-scale="1" class="mr-3" />Consumíveis
          </b-list-group-item>
        </b-list-group>
      </b-collapse>
      <!-- :::::::::::::::::::::::::::: MENU RELATÓRIOS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('RELATORIO')" button class="menu-top" @click="display('CERTIFICADO')">
        <b-icon icon="search" class="mr-3" variant="info" /> Emissão de Relatórios
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU EQUIPES :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('EQUIPE')" button class="menu-top" @click="display('EQUIPE')">
        <b-icon icon="person-lines-fill" class="mr-3" variant="info" /> Controle de Equipes
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU SERVICOS :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('SERVICO')" button class="menu-top" @click="display('ATIVIDADE')">
        <b-icon icon="wrench" variant="info" class="mr-3" /> Serviços - Atividades
      </b-list-group-item>
      <b-list-group-item v-if="getAcesso('SERVICO')" button class="menu-top" @click="display('AVULSO')">
        <b-icon icon="screwdriver" variant="info" class="mr-3" /> Serviços - Avulsos
      </b-list-group-item>
      <!-- :::::::::::::::::::::::::::: MENU FATURAMENTO :::::::::::::::::::::::::::: -->
      <b-list-group-item v-if="getAcesso('FINANCEIRO')" v-b-toggle.faturamentos button class="menu-top">
        <b-icon icon="graph-up" class="mr-3" variant="info" /> Financeiro
      </b-list-group-item>
      <b-collapse id="faturamentos">
        <b-list-group>
          <b-list-group-item variant="secondary" button @click="display('ORCAMENTO')">
            <b-icon variant="info" icon="file-ruled" class="mr-3" />Orçamentos
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('PRODUTO')">
            <b-icon variant="info" icon="box-seam" class="mr-3" />Produtos
          </b-list-group-item>
          <b-list-group-item variant="secondary" button @click="display('FATURAMENTO')">
            <b-icon variant="info" icon="currency-exchange" class="mr-3" />Faturamento
          </b-list-group-item>
        </b-list-group>
      </b-collapse>
    </b-list-group>
  </div>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import Aba from "@/models/Aba";
import Security from "@/tools/Security";

export default {
  name: "SgcqSideBar",

  data() {
    return {
      seguranca: new Security(),
    };
  },

  methods: {
    display(nomeDaAba) {
      let check = false;
      this.abas.findIndex((value) => {
        if (value.tipo == nomeDaAba) {
          check = true;
        }
      });
      switch (nomeDaAba) {
        case "ORCAMENTO":
          this.$router.push({ path: "/orcamentos" });
          break;
        case "CERTIFICADO":
          this.$router.push({ path: "/certificados" });
          break;
        case "PRIORIDADE_DASH":
          this.$router.push({ path: "/prioridades" });
          break;
        default:
          if (check) {
            this.store.REMOVE_ABA(nomeDaAba);
          } else {
            this.store.ADICIONA_ABA(new Aba(nomeDaAba, true, null));
          }
      }
    },

    getAcesso(modulo) {
      return this.seguranca.access(this.usuario, modulo);
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
      abas: store.getAbas,
      usuario: store.getUser,
    };
  },
};
</script>

<style lang="scss" scoped>
#side-bar {
  display: inline-block;
  width: 20%;
  height: 88vh;
  background-color: #112a4a;
  overflow: scroll;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  text-align: start;
}

.menu-top {
  background-color: #112a4a;
  color: #fff;
  border: none;
}
</style>
